<template>
  <div>
      <div class="back-bar flex com-model m-b-15" @click="goback">
        <img src="../../assets/images/arrowleft_icon.png" />
        <span>返回首页</span>
    </div>
    <div class="pj-all m-b-15" v-if="compyInfo">
        <!-- 企业总评 -->
        <div class="pj-compy">
            <div class="pj-tit">用户综合评分</div>
            <star-temp :star-num=$store.state.hrinfo.fullEval></star-temp>
            <div class="pj-juti-score">{{$store.state.hrinfo.fullEval}}分</div>
        </div>
        <div class="pj-juti">
            <ul>
                <li>
                    <div class="pj-juti-tit">招聘人员服务：</div>
                     <star-temp :star-num=$store.state.hrinfo.hrEval></star-temp>
                    <div class="pj-juti-score">{{$store.state.hrinfo.hrEval}}分</div>
                </li>
                <li>
                    <div class="pj-juti-tit">招聘流程规范：</div>
                    <star-temp :star-num=$store.state.hrinfo.recruitEval></star-temp>
                    <div class="pj-juti-score">{{$store.state.hrinfo.recruitEval}}分</div>
                </li>
            </ul>
            <ul>
                <li>
                    <div class="pj-juti-tit">工作环境情况：</div>
                    <star-temp :star-num=$store.state.hrinfo.workEnvEval></star-temp>
                    <div class="pj-juti-score">{{$store.state.hrinfo.workEnvEval}}分</div>
                </li>
                <li>
                    <div class="pj-juti-tit">生活环境情况：</div>
                     <star-temp :star-num=$store.state.hrinfo.liveEnvEval></star-temp>
                    <div class="pj-juti-score">{{$store.state.hrinfo.liveEnvEval}}分</div>
                </li>
            </ul>
        </div>
    </div>
    <!-- 评价列表 -->
    <div class="pj-con">
        <div class="pj-con-head">
            <div class="pj-tiao">求职者评价
                <span>(共{{pageTotal > -1 ? pageTotal : 0}}条)</span>
            </div>
        </div>
        <div class="pj-list">
            <div class="pj-item" v-for="item in rows">
                <div class="pj-item-img">
                    <img :src="item.workerHead">
                </div>
                <div class="pj-item-info">
                    <div class="pj-user" v-if="item.isAnon">匿名用户</div>
                    <div class="pj-user" v-else>{{item.workerName || '匿名用户'}}</div>
                    <div class="pj-tot">
                        <star-temp :star-num=item.fullEval></star-temp>
                        <ul class="pjrecu-list">
                            <li>招聘人员服务：<span>{{item.hrEval | calAttitude}}</span></li>
                            <li>招聘流程规范：<span>{{item.recruitEval | calAttitude}}</span></li>
                            <li>工作环境情况：<span>{{item.workEnvEval | calAttitude}}</span></li>
                            <li>生活环境情况：<span>{{item.liveEnvEval | calAttitude}}</span></li>
                        </ul>
                    </div>
                    <div class="pj-txt">
                        <p>{{item.content}}</p>
                    </div>
                    <div class="pj-item-foot flex">
                        <div class="pj-time">
                            <span >评价时间：</span>
                            <span>{{item.evalAt.split(' ')[0]}}</span>
                        </div>
                        <div class="pj-report flex" :class="[item.status=== 2 ? 'pj-report-examine':'']" @click="Report(item)">
                            <img src="../../assets/images/company/jubao_icon.png" />
                            <span  v-if="item.status == 0 || item.status == 1">举报不实评论</span>
                            <span  v-if="item.status == 2">已举报，请等待运营核实</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <ztx-paging class="ztx-paging" v-if="pageTotal*1 > -1" style="padding-bottom: 22px;" :page-size="pageSize" :page-num="pageNum" :page-total="pageTotal"
                            @currentChange="handleCurrent"></ztx-paging> -->
        <el-pagination
                    v-show="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrent"
                    :current-page="pageNum"
                    :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal" style="margin-top: 40px; padding-bottom: 40px">
                </el-pagination>
    </div>
    <div v-if="isReportTan && reportObj">
        <div class="ztx-modal"></div>
        <div class="ztx-message-box">
            <div class="ztx-message-main" style="width:580px;">
                <div class="ztx-message-tit">
                    <div>举报不实评价</div>
                    <div class="iconfont icon-guanbi ztx-message-close" @click="clodeTan"></div>
                </div>
                <div class="jubao-box">
                    <div class="jubao-tit">举报对象</div>
                    <div class="jubap-con" style="font-size:14px;">
                        <div class="jubao-ut">
                            <div class="jubao-user">
                                <span class="jubao-user-name">{{reportObj.reportUser}}</span>
                                <span class="jubao-user-text">·综合评价：</span>
                                <span class="jubao-user-score">{{reportObj.fullEval}}分</span>
                            </div>
                            <div class="jubao-time" style="color:#999;">
                                <span class="iconfont icon-pingjiashijian"></span>
                                <span>{{reportObj.evalAt.split(' ')[0]}}</span>
                            </div>
                        </div>
                        <ul class="jubao-pj">
                            <li>
                                <span>招聘人员服务：</span>
                                <span class="jubao-pj-we">{{reportObj.hrEval | calAttitude}}</span>
                            </li>
                            <li>
                                <span>招聘流程规范：</span>
                                <span class="jubao-pj-we">{{reportObj.recruitEval | calAttitude}}</span>
                            </li>
                            <li>
                                <span>工作环境情况：</span>
                                <span class="jubao-pj-we">{{reportObj.workEnvEval | calAttitude}}</span>
                            </li>
                            <li>
                                <span>生活环境情况：</span>
                                <span class="jubao-pj-we">{{reportObj.liveEnvEval | calAttitude}}</span>
                            </li>
                        </ul>
                        <div class="jubao-txt">
                            <i>{{reportObj.content}}</i>
                        </div>
                    </div>
                    <div class="jubao-tit" style="margin-top:30px;">举报原因</div>
                    <textarea :class="['jubao-area',isReportWarnning ? 'jubao-area-error':'']" @blur="reportReasonBlur" @focus="reportReasonFocus" placeholder="请填写您的举报原因" v-model="reportReason"></textarea>
                </div>
                <div class="jubao-btn" :class="[reportReason.length > 0 ? '':'jubap-btn-nocondition']" @click="goJubao">立即举报</div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import Pageing from "../../components/Pageing"; //分页
import valuationStar from "../../components/valuationStar.vue"; // 星星评价组件
let qs = require("qs");
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      compyInfo: {}, // 公司详情
      rows: [], // 评价列表
      pageTotal: -1, // 评价总条数
      isReportTan: false,
      reportObj: null, // 弹框obj
      reportReason: "", // 举报原因
      isReportWarnning: false
    };
  },
  components: {
    starTemp: valuationStar,
    ztxPaging: Pageing
  },
  created: function() {
    this.getDetail();
    this.getList();
  },
  filters: {
    //   使用过滤器来算服务好坏
    calAttitude(value) {
      let attitudetxt = "非常好";
      switch (value) {
        case 1:
          attitudetxt = "非常差";
          break;
        case 2:
          attitudetxt = "差";
          break;
        case 3:
          attitudetxt = "一般";
          break;
        case 4:
          attitudetxt = "好";
          break;
        default:
          attitudetxt = "非常好";
      }
      return attitudetxt;
    }
  },
  watch: {
    pageNum() {
      this.getList();
    }
  },
  methods: {
    // 弹窗关闭
    clodeTan() {
      this.isReportTan = false;
    },
    reportReasonBlur() {
      if (this.reportReason.length == "") {
        this.isReportWarnning = true;
      }
    },
    reportReasonFocus() {
      this.isReportWarnning = false;
    },
    goback() {
      this.$router.back();
    },
    // 获取评价列表
    getList() {
      let url = "/wapi/eval/page?pageNum=" + this.pageNum + "&pageSize=" + this.pageSize ;
      this.axios.get(url).then(res => {
        this.pageTotal = res.total;
        this.rows = res.rows.map( _j => {
            if(!_j.workerHead){
                _j.workerHead = '//oss.51ztx.com/resu.png'
            }
            return _j;
        });
      });
    },
    // 获取公司详情
    getDetail() {
      let url = "/wapi/company/detail";
      this.axios.get(url).then(res => {
        if (res.success) {
          this.compyInfo = res.data;
        }
      });
    },
    // 打开举报弹窗
    Report(obj) {
      let reportObj = Object.assign(obj, {
        reportUser: obj.isAnon ? "匿名用户" : obj.workername
      });
      this.reportObj = reportObj;
      this.isReportTan = true;
    },
    // 举报按钮触发
    goJubao() {
      if (this.reportReason.length == "") {
        this.isReportWarnning = true;
        return;
      }
      let url = "/wapi/eval/report";
      let qdata = {
        evaluationId: this.reportObj.id,
        reportReason: this.reportReason
      };
      this.axios.post(url, qs.stringify(qdata)).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "举报成功",
            duration: 1500
          });
          this.isReportTan = false;
          this.getList()
        }
      });
    },
    // 分页处理
    handleCurrent(val) {
      this.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../../assets/less/base.less');
@import "../../assets/css/public";
@import "../../assets/css/valuation";
.back-bar{
  padding: 22px 24px;
  line-height: 30px;
  color: rgba(85, 85, 85, 1);
  border-radius: 10px;
  img{
    width: 16px;
    height: 16px;
    margin-right: 16px;

  }
}
// 评价less

.pj-all {
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
}
.padding-left{
  padding-left: 24px;
}
// 企业总评
.pj-compy {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #e5e5e5;
    overflow: hidden;
    margin-bottom: 16px;
    .padding-left;
    .iconfont {
        color: #ccc;
        float: left;
    }
    .pj-tit {
        float: left;
        margin: 0 10px 0 8px;
        font-weight: bold;
    }
}

// 具体四项评价
.pj-juti {
    font-size: 14px;
    color: #666;
    .padding-left;
    padding-bottom: 16px;
    ul {
        line-height: 20px;
        display: flex;
        flex-wrap: wrap;
        line-height: 38px;
        li {
            width: 450px;
            display: flex;
            align-items: center;
        }
    }
}
.pj-con {
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    border-radius: 10px;
}
// 评价条数
.pj-con-head {
    height: 56px;
    line-height: 56px;
    .iconfont {
        color: #ccc;
        margin-right: 8px;
        float: left;
    }
    .pj-tiao {
        color: #333;
        float: left;
        font-weight: bold;
    }
    .pj-tiao span {
        color: #999;
        font-weight: normal;
    }
}

// 评价列表
.pj-list {
    overflow: hidden;
}
.pj-item {
    overflow: hidden;
    padding: 20px 0;
    border-bottom: 1px solid #e5e5e5;
    .pj-item-img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        float: left;
        margin-right: 24px;
        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;

        }
    }
    .pj-item-info {
        float: left;
        overflow: hidden;

        .pj-tot {
            overflow: hidden;
             margin-top: 8px;
        }
        .pj-item-user {
            font-size: 16px;
            color: #666;
        }
        .pjrecu-list {
            float: left;
            span{
                font-weight: bold;
            }
        }
        .pjrecu-list li {
            font-size: 14px;
            float: left;
            color: #999;
            padding: 0 10px;
            position: relative;
            &::after {
                content: "";
                width: 1px;
                height: 14px;
                background-color: #ccc;
                position: absolute;
                top: 3px;
                right: 0;
            }
            &:last-child::after {
                width: 0;
            }
        }
        .pj-txt {
            margin: 15px 0;
            color: #666;
        }
    }
    .pj-item-foot {
        overflow: hidden;
    }

    .pj-time {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-right: 40px;
    }

    .pj-report {
        font-size: 14px;
        cursor: pointer;
        color: rgba(153, 153, 153, 1);
        img{
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
    }
    // .pj-report-examine{
    //     color: #ccc;
    // }
}


</style>




// WEBPACK FOOTER //
// valuation.vue?bb8a0dae